import getDataLayer from './getDataLayer';
import { getOwnCategory } from '../getOwnCategory';
import { DL_CURRENCY, DlEcommerceEvents, DlEventSource } from './constant';
import { ICartItem } from '../../typings/ICartItem';
import { ICartState } from '../../redux/cart/cartTypes';

export const DL_ViewCart = (cart: ICartState, dlEventSource: DlEventSource) => {
  const cartItems = cart?.cartData || [];
  getDataLayer().push({
    event: DlEcommerceEvents.VIEW_CART,
    ecommerce: {
      currency: DL_CURRENCY,
      value: cart.productsPrice,
      items: [
        ...cartItems.map((cartItem: ICartItem, index: number) => {
          const product = cartItem.product;
          const customCategory = getOwnCategory(product?.customCategories);
          const cartProductPrice = (Number(cartItem.price) / cartItem.count).toFixed(2);
          return {
            item_name: product?.titleDe || product?.title,
            item_id: product?.id,
            item_category: customCategory?.name,
            item_brand: product?.brand?.nameDe,
            item_list_id: dlEventSource.id,
            item_list_name: dlEventSource.name,
            price: cartProductPrice,
            quantity: cartItem.count,
            index: index,
          };
        }),
      ],
    },
  });
};
